import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "bp-pill-info",
	templateUrl: "./bp-pill-info.component.html",
	styleUrls: ["./bp-pill-info.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpPillInfoComponent {}
